/**
 * Labstep
 */

import type { ParamsHOCChildrenProps } from 'labstep-web/hoc/Params/types';
import type { User } from 'labstep-web/models/user.model';
import { PostFilterAssignedTo } from 'labstep-web/services/postFilter/filters/assignedTo';
import { PostFilterAuthor } from 'labstep-web/services/postFilter/filters/author';
import type { FilterUserType } from './types';

export const onUserChange = (
  selectedOption: User | null,
  type: FilterUserType,
  setParams: ParamsHOCChildrenProps['setParams'],
  addPostFilter?: ParamsHOCChildrenProps['addPostFilter'],
): void => {
  if (addPostFilter) {
    const guid = selectedOption ? selectedOption.guid : undefined;
    addPostFilter(
      type === 'author'
        ? PostFilterAuthor.getNode([guid])
        : PostFilterAssignedTo.getNode([guid]),
    );
  } else {
    setParams({
      [type === 'author' ? 'author_id' : 'assignee_id']:
        selectedOption ? selectedOption.id : undefined,
    });
  }
};
